<template>
  <div>
    <apexchart
      type="bar"
      height="204"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    graphData: {
      required: true
    }
  },
  watch: {
    graphData: {
      handler(newVal) {
        if (!newVal || !newVal.monthlyStatusBreakdown) return;
        this.filterDataByType(newVal.monthlyStatusBreakdown);
        this.getMonths(newVal.monthlyStatusBreakdown);
      }
    }
  },
  data() {
    return {
      series: [
        { name: "Posted", data: [] },
        { name: "Paid", data: [] },
        { name: "Failed", data: [] },
        {name:"Processing",data:[]},
        { name: "Dispute", data: [] }
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: true,
            export: {
              csv: {
                filename: 'payment_status',
              },
              svg: {
                filename: 'payment_status',
              },
              png: {
                filename: 'payment_status',
              }
            },
            tools: {
              pan: false,
              zoom: true
            }
          },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "40%",
            endingShape: "rounded",
            borderRadius: 3
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: [],
          title: {
            text: 'Month'
          }
        },
        yaxis: {
          title: {
            text: 'Amount ($)'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: (val, { seriesIndex, dataPointIndex, w }) => {
              const month = w.globals.labels[dataPointIndex]; 
              const type = w.config.series[seriesIndex].name.toLowerCase(); 
              const amount = this.getAmount(month, type); 
              const count = this.getCount(month, type); 
              return `Count: ${count}, Amount: $${amount}`;
              // return `Amount:$${amount}`;
            }
          }
        },
        legend: {
          show: true,
        },
        colors: ["#DEA600", "#3CA653", "#FF0000", "#6072DB", "#BD52D1"]
      }
    };
  },
  methods: {
    filterDataByType(data) {
      const typeIndices = {
        posted: 0,
        paid: 1,
        failed: 2,
        processing:3,
        dispute: 4
      };
      this.series.forEach(s => (s.data = []));
      const months = Object.keys(data);
      this.chartOptions = {
  ...this.chartOptions,
  xaxis: {
    ...this.chartOptions.xaxis,
    categories: [...months]
  }
};

      months.forEach(month => {
        const types = data[month];
        const monthData = [0, 0, 0, 0, 0];
        Object.keys(types).forEach(type => {
          if (type in typeIndices) {
            const index = typeIndices[type];
            // monthData[index] = parseFloat(types[type].count);
            monthData[index] = parseFloat(types[type].amount);
          }
        });
        monthData.forEach((value, index) => {
          this.series[index].data.push(value);
        });
      });

    },

    getMonths(data) {
      let months = Object.keys(data);
      this.chartOptions = {
  ...this.chartOptions,
  xaxis: {
    ...this.chartOptions.xaxis,
    categories: [...months]
  }
};
    },
    getAmount(month, type) {
      return this.graphData.monthlyStatusBreakdown[month][type].amount;
    },
    getCount(month, type) {
      return this.graphData.monthlyStatusBreakdown[month][type].count;
    }
  }
};
</script>
